import { render, staticRenderFns } from "./ModalAddCarrinho.vue?vue&type=template&id=401a55ec&scoped=true"
import script from "./ModalAddCarrinho.vue?vue&type=script&lang=js"
export * from "./ModalAddCarrinho.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCarrinho.vue?vue&type=style&index=0&id=401a55ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a55ec",
  null
  
)

export default component.exports